import { useEffect, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { FaList, FaPlus, FaRegEdit, FaTrashAlt } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactTable from '../../../../Components/ReactTable/ReactTable';
// import { clearTable, deleteTableData, handleThematicAreaListChange } from '../../../../Redux/slices/table';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { toast } from 'react-toastify';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import {
  clearTable,
  deleteTableData,
  handleThematicAreaListChange
} from '../../../../Redux/slices/table';
import { useState } from 'react';
import { VscLoading } from 'react-icons/vsc';

function ThematicArea() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const local = useSelector((state) => state.local.local);
  const results = useSelector((state) => state.table.results);

  const [isLoading, setIsLoading] = useState(false);
  const columns = useMemo(
    () => [
      { Header: <FormattedMessage id="sn" />, accessor: 'serial_number' },
      {
        Header: <FormattedMessage id="title" />,
        accessor: 'title'
      },

      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'actions'
      }
    ],
    []
  );

  const handleThematicAreaEdit = (id) => {
    navigate(`/admin/settings/thematic_area/${id}/edit`);
  };
  const handleThematicAreaDelete = async (id) => {
    try {
      setIsLoading(id);
      await fetchWrapper.delete(`/thematicarea/${id}/`);
      dispatch(deleteTableData(id));
      toast.success(<FormattedMessage id="thematic_area_deleted" />);
      navigate('/admin/settings/thematic_area/');
      setIsLoading(null);
    } catch (error) {
      ErrorMessageHandler(error);
      setIsLoading(null);
    }
  };

  const data = useMemo(() => {
    if (!results) return [];

    let count = 1;
    return results.map((result) => {
      let action = (
        <div className="d-flex">
          {/* <div>
            <Button variant="outline-info">
              <FaEye />
            </Button>
          </div> */}
          <div className="mx-2">
            <Button variant="outline-success " onClick={() => handleThematicAreaEdit(result.id)}>
              <FaRegEdit />
            </Button>
          </div>
          <div className="mx-2">
            {result.can_delete ? (
              <Button
                variant="outline-danger "
                onClick={() => handleThematicAreaDelete(result.id)}
                disabled={isLoading}>
                {isLoading ? <VscLoading className="spin" /> : <FaTrashAlt />}
              </Button>
            ) : (
              ''
            )}
          </div>
        </div>
      );
      return {
        serial_number: count++,
        title:
          local === 'ne'
            ? result.title_nepali
            : result.title_english
            ? result.title_english
            : result.title_nepali,

        actions: action
      };
    });
  }, [results, local]);

  const handleThematicAreaFetch = ({ index, pageSize }) => {
    dispatch(handleThematicAreaListChange({ index: index, pageSize: pageSize }));
  };
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  return (
    <div className="card content-section p-3">
      <div className="card-header d-flex justify-content-between align-items-end">
        <h4 className="d-inline-block text-primary">
          <FaList className="me-2" />
          <FormattedMessage id="thematic_area" />
        </h4>
        <div className="d-flex justify-content-between align-items-end">
          <Button variant="primary">
            <Link to="new" className="text-light">
              <FaPlus size={18} />
              <FormattedMessage id="add_new" />
            </Link>
          </Button>
        </div>
      </div>
      <hr />

      <div className="">
        <ReactTable data={data} columns={columns} dataFetcher={handleThematicAreaFetch} />
      </div>
    </div>
  );
}

export default ThematicArea;
